import { render, staticRenderFns } from "./diff_viewer.vue?vue&type=template&id=9e3985a0&"
import script from "./diff_viewer.vue?vue&type=script&lang=js&"
export * from "./diff_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "diff_viewer.vue"
export default component.exports